<template>
  <!--
      	作者：lpf
      	时间：2019-06-04
      	描述：门店
      -->
  <div>
    <!--门店列表-->
    <Store v-if="activeName == 'store'"></Store>
    <!--订单核销记录-->
    <Order v-if="activeName == 'order'"></Order>
    <!--店员列表-->
    <Clerk v-if="activeName == 'clerk'"></Clerk>
    <!-- 设置 -->
    <Setting v-if="activeName == 'setting'"></Setting>
  </div>
</template>
<script>
import bus from '@/utils/eventBus.js';
// import PlusApi from '@/api/plus.js';
import Store from './store/index';
import Order from './order/index';
import Clerk from './clerk/index';
import Setting from './setting/getSetting';

export default {
  components: {
    Store,
    Clerk,
    Order,
    Setting
  },
    data() {
    return {
      formInline: {
        nick_name: ''
      },
      /*参数*/
      param: {},
      /*当前选中*/
      activeName: 'store',
      /*切换数组*/
      sourceList: [
        {
          key: 'store',
          value: '门店列表',
          path:'/store/store/index'
        },
        {
          key: 'order',
          value: '订单核销记录',
          path:'/store/order/index'
        },
        {
          key: 'clerk',
          value: '店员',
          path:'/store/clerk/index'
        },
        {
          key: 'setting',
          value: '门店设置',
          path:'/store/setting/getSetting'
        },
      ],
      /*权限筛选后的数据*/
      tabList:[],
      /*判断third是否有参数*/
      is_third_param: false
    };
  },
  watch:{

    //监听路由
    $route(to, from) {
      this.init();
    }
  },
  created() {

    this.init();

  },
  beforeDestroy() {
    //发送类别切换
    bus.$emit('tabData', { active: null, tab_type:'store',list: [] });
    bus.$off('activeValue');
  },
  methods: {

    /*初始化方法*/
    init(){
      this.tabList=this.authFilter();

      if(this.tabList.length>0){
        this.activeName=this.tabList[0].key;
      }

      if (this.$route.query.type != null) {
        this.activeName = this.$route.query.type;
      }

      /*监听传插件的值*/
      bus.$on('activeValue', res => {
        if (this.is_third_param) {
          this.param.user_id = '';
          this.is_third_param = false;
        }
        this.activeName = res;
      });

      //发送类别切换
      let params = {
        active: this.activeName,
        list: this.tabList,
        tab_type:'store'
      };
      bus.$emit('tabData', params);
    },

    /*权限过滤*/
    authFilter(){
      let list=[];
      for(let i=0;i<this.sourceList.length;i++){
        let item=this.sourceList[i];
        if(this.$filter.isAuth(item.path)){
          list.push(item);
        }
      }
      return list;
    }

  }
};
</script>



// WEBPACK FOOTER //
// src/views/store/index.vue